$(() =>
  $("#karte-report-delete").on("click", () =>
    confirm("本当に削除してよろしいですか？")
  )
);
